import { DealPipelineWorkflowService } from "src/app/services/settings-services/deal-pipeline-workflow.service";
import { TeamsService } from "./../../../services/crew-services/teams.service";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { SalesPersonService } from "src/app/services/crew-services/sales-person.service";
import { Observable } from "rxjs";
import { COMPAREAR_REMOVEMATCH } from "src/app/helpers/helperResources";

@Component({
  selector: "app-add-teams-modal",
  templateUrl: "./add-teams-modal.component.html",
  styleUrls: ["./add-teams-modal.component.css"],
})
export class AddTeamsModalComponent implements OnInit, OnChanges {
  @Output() emitTeamList = new EventEmitter();
  @Input() workflowSalesPerson: Observable<any>;
  @Input() workflowID;
  workflowSalesPersonArrList;
  // workflowTeams;
  teamList$;
  constructor(
    private teamSrv: TeamsService,
    private salespersonSrv: SalesPersonService,
    private dealWorkflow: DealPipelineWorkflowService
  ) {}
  selectedTeams: any[];
  loadingReq = false;
  dropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 2,
    allowSearchFilter: true,
  };
  personsRemovedFromList;

  ngOnInit() {
    // this.fetchWorkflowTeam();
  }

  ngOnChanges(changes: SimpleChanges) {
    const type = 5;
    const { workflowSalesPerson: { currentValue: salespersonList }} = changes;
    if (salespersonList) {
      salespersonList.subscribe((attachedSalesperson) => {
        this.salespersonSrv.fetchSalesperson(type).subscribe((SP_list: any) => {
          let result = COMPAREAR_REMOVEMATCH(
            SP_list,
            attachedSalesperson,
            "id"
          );
          this.teamList$ = result.newList;
          this.personsRemovedFromList = result.removedFrmList;
        });
      });
    }
  }

  launchModal() {
    document.getElementById("AddTeamModal").click();
  }

  // fetchWorkflowTeam() {
  //   if (this.workflowID) {
  //     this.dealWorkflow
  //       .getWorkflowTeams(this.workflowID)
  //       .subscribe((res: any) => {
  //         this.workflowTeams = res;
  //       });
  //   }
  // }

  closeModal() {
    this.loadingReq = false;
    document.getElementById("closeAddTeamModal").click();
    this.selectedTeams = [];
  }

  save() {
    const removedIds = this.personsRemovedFromList.map((person) => person.id);
    const personsIds = this.selectedTeams.map((person) => person.id);
    const allSalespersonIds = [...removedIds, ...personsIds];
    this.loadingReq = true;
    this.emitTeamList.emit(allSalespersonIds);
  }
}
